module.exports = __webpack_public_path__ + "static/2017-8787f0c729df7f17f8e02a5f71f7d646.webp";